import moment from 'moment'
import anchorme from 'anchorme'

function addHeader(msgs, item, lastDate) {

  let newDate = moment(item.created_at).format('YYYYMMDD')
  if (lastDate != newDate)
    msgs.push({
      template: 'DateHeader',
      created_at: item.created_at
    })

  return newDate
}

function addAttachment(item,uid) {

  if (item.type != 2 ||
    item.abort == true ||
    !item.meta.filter(
      meta => meta.upload == 100 && meta.url
    ).length
  )
    return null

  return {
    template: 'Attachment',
    from: item.from,
    meta: item.meta,
    read: item.read ? item.read[uid] : false,
    delivered: item.delivered ? item.delivered[uid] : false,
    created_at: item.created_at
  }

}

function addMessage(item,uid) {

  if ([0,3].indexOf(item.type) < 0 ||
    item.private
  )
    return null

  return {
    template: 'Message',
    from: item.from,
    created_at: item.created_at,
    message: item.message,
    read: item.read ? item.read[uid] : false,
    delivered: item.delivered ? item.delivered[uid] : false,
    grabber: item.grabber,
    links: anchorme(item.message, {list:true}),
    tail: true
  }

}

function addMedia(msgs, { links, operator, from, created_at, template }) {

  if (links && links.length)
    for (let j=0; j<links.length; j++) {

      let link = links[j]
      if (link.reason == 'url') {

        //add future items here
        let media = youTube(link.raw) ||
          imageUrl(link.raw) ||
          videoUrl(link.raw) ||
          audioUrl(link.raw)

        if (media) {

          msgs[msgs.length-1].tail = false

          msgs.push({
            template,
            operator,
            from,
            created_at,
            media,
            tail: true
          })

        }

      }

    }

}

//media types - consider moving to components
function youTube(url) {

  let regExp = /^.*(youtu.be\/|v\/|u\/\w\/|embed\/|watch\?v=|\&v=)([^#\&\?]*).*/
  let match = url.match(regExp)

  if (!match || match[2].length < 11)
    return null

  return {
    type: 'iframe',
    src: 'https://www.youtube.com/embed/'+match[2]+'?controls=1&showinfo=1'
  }

}

function imageUrl(url) {

  if (!url.match(/\.gif|\.png|\.jpe?g/))
    return null

  return {
    type: 'image',
    src: url
  }

}

function videoUrl(url) {

  let v = document.createElement('video')

  if (!url.match(/\.mp4/) ||
    (!v.canPlayType || !v.canPlayType('video/mp4'))
  )
    return null

  return {
    type: 'video',
    src: url
  }

}

function audioUrl(url) {

  let a = new Audio()

  if (!url.match(/\.mp3/) ||
    (!a.canPlayType || !a.canPlayType('audio/mp3'))
  )
    return null

  return {
    type: 'audio',
    src: url
  }

}

export default {
  getPageEventSid(state) {
    return state.pageEventSid
  },
  getPageEventKey(state) {
    return state.pageEventKey
  },
  getPageEventSubKey(state) {
    return state.pageEventSubKey
  },
  getLastPageEvent(state) {

    const items = state.messages ? state.messages.data : {}
    let evt = null
    let lastLeftAt = 0
    for (let i in items)
      if (items[i].type == 1 &&
        items[i].subtype == 2 &&
        items[i].left_at &&
        items[i].left_at > lastLeftAt
      ) {

        lastLeftAt = items[i].left_at
        evt = {
          msgKey: i,
          ...items[i]
        }

      }

    return evt

  },
  isOperatorTyping(state) {
    return state.messages && state.messages.actions && state.messages.actions.isOperatorTyping ? true : false
  },
  getNewMessage(state) {
    const items = state.messages ? state.messages.data : {}
    const uid = state.uid
    let msg = null
    for (let i in items)
      if ([0,3].indexOf(items[i].type) >= 0 &&
        !(items[i].read &&
        items[i].read[uid]) &&
        items[i].from != state.uid
      )
        msg = {
          msgKey: i,
          ...addMessage(items[i],uid)
        }

    return msg

  },
  getUnread(state) {

    const uid = state.uid
    const items = state.messages ? state.messages.data : {}

    let count = 0

    for (let i in items) {
      if (items[i].from != uid &&
        [0,3].indexOf(items[i].type) >= 0 &&
        !items[i].private &&
        !(items[i].read &&
          items[i].read[uid])
      )
        count += 1
    }

    return count

  },
  getCache(state) {
    return state.cache ? state.cache : []
  },
  getAPIMessages(state) {

    if (!(state.messages && state.messages.data))
      return []

    const items = state.messages.data
    let msgs = Object.keys(items).map((key)=>items[key]).filter((item)=>{
      if (item.from == state.orgId)
        return true
    })

    return msgs
  },
  getMessages(state) {

    const items = state.messages ? state.messages.data : {}
    const uid = state.uid
    const msgs = []

    let lastDate = null
    let lastItem = null

    for (let i in items) {

      let item = addAttachment(items[i],uid) || addMessage(items[i],uid)


      if (item) {

        lastDate = addHeader(msgs, item, lastDate)
        lastItem = msgs[msgs.length-1]

        if (lastItem &&
          item.tail &&
          lastItem.tail &&
          lastItem.from == item.from
        )
          lastItem.tail = false

        item.operator = item.from != state.uid
        item.msgKey = i
        msgs.push(item)

        if (item.links)
          addMedia(msgs, item)

      }

    }

    return msgs

  }
}
